<script>
  import { createEventDispatcher } from "svelte";
  import {
    toHHMMSS,
    getShareLink,
    getWorkoutName,
    getSaveLink,
    id,
  } from "../utils/utils.js";
  import { notifications } from "../utils/notifications.js";
  import { onMount } from "svelte";
  import Clipboard from "svelte-clipboard";
  import { myWorkouts } from "../utils/myWorkoutStore";
  export let setup;

  const dispatch = createEventDispatcher();

  let url;
  let shareLink;

  onMount(() => (url = window.location.href));

  $: totalTime = setup.type === "rft" ? "GO" : toHHMMSS(setup);

  function startWorkout() {
    dispatch("startWorkout", setup);
  }

  $: shareLink = getShareLink(url, setup);

  function share() {
    notifications.success("Link copied to clipboard.", 1000);
  }
  function save() {
    if (setup.id) {
      let saveLink = getSaveLink(setup.id, url, setup);
      let oldWorkout = myWorkouts.get(setup.id);
      const newWorkOut = {
        id: setup.id,
        name: getWorkoutName(setup, oldWorkout.name),
        url: saveLink,
        type: setup.type,
        timestamp: new Date(),
        isEdit: false,
      };
      myWorkouts.update(setup.id, newWorkOut);
      notifications.success(`Updated ${newWorkOut.name}`, 1000);
    } else {
      let idNew = id();
      let saveLink = getSaveLink(idNew, url, setup);
      const newWorkOut = {
        id: idNew,
        name: getWorkoutName(setup),
        url: saveLink,
        type: setup.type,
        timestamp: new Date(),
        isEdit: false,
      };
      myWorkouts.add(newWorkOut);
      notifications.success(`Saved ${newWorkOut.name}`, 1000);
    }
  }
</script>

<div class="w-full flex justify-center items-center gap-x-2">
  <Clipboard text={shareLink} let:copy on:copy={share}>
    <button
      title="Share"
      on:click={copy}
      aria-label="Share"
      class="active:text-gray-400 p-1 cursor-pointer select-none focus:outline-none transform hover:scale-125 focus:scale-125 transition duration-200 ease-in-out rounded-lg focus:bg-gray-300 focus:bg-opacity-30"
    >
      <svg class="h-6 w-6 fill-current" viewBox="0 0 20 20" fill="currentColor">
        <path
          d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z"
        />
      </svg>
    </button>
  </Clipboard>
  <button
    title="Start workout"
    on:click={startWorkout}
    aria-label="Start workout"
    class="uppercase w-full flex justify-center items-center gap-x-2 bg-red-600 text-2xl font-bold py-2 rounded-full focus:outline-none focus:ring ring-red-600 ring-opacity-80 transform hover:scale-105 focus:scale-105 transition duration-100 ease-in-out active:text-gray-300"
    >{totalTime}
    <svg class="h-6 w-6 fill-current" viewBox="0 0 24 24"
      ><path
        d="M5.536,21.886C5.682,21.962,5.841,22,6,22c0.2,0,0.398-0.06,0.569-0.178l13-9C19.839,12.635,20,12.328,20,12 s-0.161-0.635-0.431-0.822l-13-9C6.264,1.967,5.865,1.942,5.536,2.114C5.206,2.287,5,2.628,5,3v18 C5,21.372,5.206,21.713,5.536,21.886z"
      /></svg
    ></button
  >
  <button
    title="Save"
    on:click={save}
    aria-label="Save"
    class="active:text-gray-400 p-1 cursor-pointer select-none focus:outline-none transform hover:scale-125 focus:scale-125 transition duration-200 ease-in-out rounded-lg focus:bg-gray-300 focus:bg-opacity-30"
  >
    <svg class="h-6 w-6 fill-current" viewBox="0 0 24 24"
      ><path
        d="M5 21h14a2 2 0 0 0 2-2V8l-5-5H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zM7 5h4v2h2V5h2v4H7V5zm0 8h10v6H7v-6z"
      /></svg
    >
  </button>
</div>
